// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewEmployeeInformation {
  background-color: #f3f4f6;
}
.viewEmployeeInformation .breadCrumb {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.viewEmployeeInformation .breadCrumb .mainScreen,
.viewEmployeeInformation .breadCrumb .secondScreen {
  display: inline-block;
  margin-right: 10px;
}
.viewEmployeeInformation .breadCrumb .secondScreen {
  margin-left: 10px;
}
.viewEmployeeInformation .contentCard {
  min-height: 590px;
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-top: 14px;
  display: flex;
  flex-direction: row;
}
.viewEmployeeInformation .contentCard .leftContainer {
  width: 25%;
  border-right: 1px solid #f2f2f2;
}
.viewEmployeeInformation .contentCard .leftContainer .profileImage {
  height: 100px;
  width: 100px;
  background-color: #c1c1c1;
  border-radius: 50px;
  text-align: center;
  padding-top: 25px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #ffffff;
  margin: auto;
  margin-top: 60px;
  margin-bottom: 20px;
}
.viewEmployeeInformation .contentCard .leftContainer .name {
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #333333;
  margin-top: 3px;
}
.viewEmployeeInformation .contentCard .leftContainer .position {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  display: flex;
  margin: auto;
  width: 77px;
}
.viewEmployeeInformation .contentCard .leftContainer .position .value {
  margin-left: 12px;
  color: #505054;
}
.viewEmployeeInformation .contentCard .rightContainer {
  width: 75%;
}
.viewEmployeeInformation .contentCard .stateCellContainer {
  display: flex;
  margin-top: 5px;
  flex-direction: row;
  justify-content: center;
}
.viewEmployeeInformation .contentCard .stateCellContainer .stateIndicator {
  height: 6px;
  width: 6px;
  border-radius: 3px;
  margin-right: 10px;
  position: relative;
  top: 5px;
}
.viewEmployeeInformation .contentCard .stateCellContainer .probation {
  position: relative;
  margin-left: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  color: #49ae9e;
  padding: 0 5px;
  background: #e5f4f2;
  border-radius: 50px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/screens/viewInformation/viewInformation.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;AAAI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAER;AAAQ;;EAEI,qBAAA;EACA,kBAAA;AAEZ;AAAQ;EACI,iBAAA;AAEZ;AAEI;EACI,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAEQ;EACI,UAAA;EACA,+BAAA;AAAZ;AAEY;EACI,aAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAAhB;AAGY;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AADhB;AAIY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AAFhB;AAGgB;EACI,iBAAA;EACA,cAAA;AADpB;AAKQ;EACI,UAAA;AAHZ;AAMQ;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AAJZ;AAKY;EACI,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAHhB;AAMY;EACI,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAJhB","sourcesContent":[".viewEmployeeInformation {\n    background-color: #f3f4f6;\n    .breadCrumb {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #868686;\n\n        .mainScreen,\n        .secondScreen {\n            display: inline-block;\n            margin-right: 10px;\n        }\n        .secondScreen {\n            margin-left: 10px;\n        }\n    }\n\n    .contentCard {\n        min-height: 590px;\n        background: #ffffff;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        margin-top: 14px;\n        display: flex;\n        flex-direction: row;\n\n        .leftContainer {\n            width: 25%;\n            border-right: 1px solid #f2f2f2;\n\n            .profileImage {\n                height: 100px;\n                width: 100px;\n                background-color: #c1c1c1;\n                border-radius: 50px;\n                text-align: center;\n                padding-top: 25px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 40px;\n                line-height: 50px;\n                color: #ffffff;\n                margin: auto;\n                margin-top: 60px;\n                margin-bottom: 20px;\n            }\n\n            .name {\n                text-align: center;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 24px;\n                line-height: 34px;\n                color: #333333;\n                margin-top: 3px;\n            }\n\n            .position {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 20px;\n                color: #868686;\n                display: flex;\n                margin: auto;\n                width: 77px;\n                .value {\n                    margin-left: 12px;\n                    color: #505054;\n                }\n            }\n        }\n        .rightContainer {\n            width: 75%;\n             \n        }\n        .stateCellContainer {\n            display: flex;\n            margin-top: 5px;\n            flex-direction: row;\n            justify-content: center;\n            .stateIndicator {\n                height: 6px;\n                width: 6px;\n                border-radius: 3px;\n                margin-right: 10px;\n                position: relative;\n                top: 5px;\n            }\n\n            .probation {\n                position: relative;\n                margin-left: 10px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 12px;\n                color: #49ae9e;\n                padding: 0 5px;\n                background: #e5f4f2;\n                border-radius: 50px;\n                text-align: center;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
